import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import JournalPartnerTagAdminForm from '../containers/JournalPartnerTagAdminFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';

class JournalPartnerTagAdminAddScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `JournalPartnerTagAdminAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  trackerActions = (eventMixpanel, params = {}) => {
    if (this.props.role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: this.props.partnershipName ?? 'No partnership',
        partnershipId: this.props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('journal_partner_tag_route_add')} />
            <JournalPartnerTagAdminForm trackerActions={this.trackerActions} />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
    this.trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.JOURNAL_PARTNER_TAGS_ADMIN_ADD_SCREEN
    );
  }
}

export default JournalPartnerTagAdminAddScreen;

Logger.log('silly', `JournalPartnerTagAdminAddScreen loaded.`);
